export default __webpack_public_path__ + "static/media/Mask Group 63.2ac7826a.svg";